import languages from "config/languages";
import { regularPages } from "./getPageUrl/config";

export const isValidAppLanguage = (language) => languages.has(language);

export const getParentLanguage = (language) => language.split("-")[0];

export const checkIfPagePathExist = (language, page) => {
  if (!page) return false;
  if (!regularPages[page]) throw new Error(`Could not find page path configuration for "${page}".`);

  const parentLang = getParentLanguage(language);
  const {
    [language]: currentLangPath,
    [parentLang]: parentLangPath,
    fallback: fallbackPath,
    parentLanguageOnly,
  } = regularPages[page];

  const parentPath = parentLanguageOnly ? false : parentLangPath;

  return !!(currentLangPath || parentPath || fallbackPath);
};

export const checkIfValidLanguage = (language) => !!languages.get(language);

export const getLocaleByLanguage = (language) => (language === "en-int" ? "en-001" : languages.get(language).hreflang);
